"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scanIList = exports.scan = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
/** @internal */
var scan = function (array, reducer, init) {
    var e_1, _a;
    var n = array.length;
    var result = new Array(n + 1).fill(init);
    var acc = init;
    try {
        for (var _b = tslib_1.__values(array.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), index = _d[0], value = _d[1];
            acc = reducer(acc, value);
            result[index + 1] = acc;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
};
exports.scan = scan;
var scanIList = function (list, reducer, init) {
    var e_2, _a;
    var n = list.size;
    var result = new Array(n + 1).fill(init);
    var acc = init;
    try {
        for (var _b = tslib_1.__values(list.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = tslib_1.__read(_c.value, 2), index = _d[0], value = _d[1];
            acc = reducer(acc, value);
            result[index + 1] = acc;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return (0, utils_1.IList)(result);
};
exports.scanIList = scanIList;
